// extracted by mini-css-extract-plugin
export default {"toggle":"Modal_toggle__YNfy8","modal":"Modal_modal__vvxhU","popup":"Modal_popup__ZBR7u","close":"Modal_close__Yp33c"};